import * as React from 'react';
import { createTheme } from '@mui/material/styles';
import { AppProvider } from '@toolpad/core/react-router-dom';
import { PageContainer } from '@toolpad/core/PageContainer';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import {
	Dashboard,
	CalendarMonth,
	BorderAll,
	Place,
	LocalConvenienceStore,
	LocalShipping,
	Route,
	ShoppingCart,
	AttachMoney,
	BarChart,
	Settings,
} from '@mui/icons-material';
import { Chip, Paper } from '@mui/material';
import LoginPage from '../pages/Login';
import { useAuth } from '../components/AuthProvider';
import { useLocation } from 'react-router-dom';

const NAVIGATION = [
	{
		segment: '',
		title: 'Dashboard',
		icon: <Dashboard />,
	},
	{
		segment: 'calendar',
		title: 'Calendar',
		icon: <CalendarMonth />,
	},
	{
		segment: 'reports',
		title: 'Reports',
		icon: <BarChart />,
	},
	{
		kind: 'divider',
	},
	{
		segment: 'products',
		title: 'Inventory',
		icon: <BorderAll />,
		/* children: [
			{
				segment: 'create',
				title: 'Create product',
			},
		], */
	},
	{
		segment: 'locations',
		title: 'Locations',
		icon: <Place />,
	},
	{
		segment: 'machines',
		title: 'Machines',
		icon: <LocalConvenienceStore />,
		action: <Chip label={7} color='primary' size='small' />,
	},
	{
		kind: 'divider',
	},
	{
		segment: 'trips',
		title: 'Trips',
		icon: <LocalShipping />,
	},
	{
		segment: 'routes',
		title: 'Routes',
		icon: <Route />,
	},
	{
		segment: 'purchases',
		title: 'Purchases',
		icon: <ShoppingCart />,
	},
	{
		segment: 'expenses',
		title: 'Expenses',
		icon: <AttachMoney />,
	},
	{
		kind: 'divider',
	},
	{
		segment: 'settings',
		title: 'Settings',
		icon: <Settings />,
	},
];

const lgWidthPages = ['/products/create'];
const noPaddingPages = ['/products'];

const Theme = createTheme({
	cssVariables: {
		colorSchemeSelector: 'data-toolpad-color-scheme',
	},
	colorSchemes: { light: true, dark: true },
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 900,
			lg: 1200,
			xl: 1536,
		},
	},
});

function MainLayout(props) {
	const location = useLocation();
	const maxWidth = lgWidthPages.includes(location.pathname) ? 'lg' : false;
	const padding = noPaddingPages.includes(location.pathname) ? 0 : 2;

	return (
		<AppProvider
			session={useAuth()}
			authentication={useAuth()}
			navigation={NAVIGATION}
			branding={{
				logo: (
					<img src='https://mui.com/static/logo.png' alt='MUI logo' />
				),
				title: 'VendingHQ',
				homeUrl: '/',
			}}
			theme={Theme}
		>
			{!useAuth().user ? (
				<LoginPage />
			) : (
				<DashboardLayout>
					<PageContainer
						maxWidth={maxWidth}
						breadcrumbs={[]}
						title={''}
					>
						<Paper sx={{ flex: 1, padding }} elevation={2}>
							{props.children}
						</Paper>
					</PageContainer>
				</DashboardLayout>
			)}
		</AppProvider>
	);
}

export default MainLayout;
